import { BieMetricRow, BieScenarioOption, BieTornadoRow, BieWaterfallRow } from './types';

const postBiz = async (payload: any) => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const json = await res.json();
  if (!res.ok || json.failure) {
    throw new Error(json.em || json.message || 'Request failed');
  }
  return json;
};

const unwrapData = (json: any) => {
  const sd =
    json.sd ||
    json.result?.sd ||
    json.data?.sd ||
    json.summary?.sd ||
    json.cards?.sd ||
    json.compare?.sd;

  return Array.isArray(sd) ? sd : [];
};

export const fetchScenarios = async (): Promise<BieScenarioOption[]> => {
  const json = await postBiz({ s: 'bieinfo', a: 'scenarios' });
  return unwrapData(json).map((x: any) => ({
    code: x.code,
    name: x.name,
    description: x.description,
  }));
};

export const fetchCards = async (scenarioCode: string): Promise<BieMetricRow[]> => {
  const json = await postBiz({ s: 'bieexecutive', a: 'cards', scc: scenarioCode });
  return unwrapData(json);
};

export const fetchCompare = async (baseScenario: string, targetScenario: string): Promise<BieMetricRow[]> => {
  const json = await postBiz({ s: 'bieexecutive', a: 'compare', bsc: baseScenario, tsc: targetScenario });
  return unwrapData(json);
};

export const fetchWaterfall = async (baseScenario: string, targetScenario: string): Promise<BieWaterfallRow[]> => {
  const json = await postBiz({ s: 'bieexecutive', a: 'waterfall', bsc: baseScenario, tsc: targetScenario });
  return unwrapData(json);
};

export const fetchTornado = async (scenarioCode: string, targetCode = 'RESPARTVAL', delta = 10): Promise<BieTornadoRow[]> => {
  const json = await postBiz({ s: 'bieexecutive', a: 'tornado', scc: scenarioCode, tdc: targetCode, dlt: delta });
  return unwrapData(json);
};

export const saveSnapshot = async (scenarioCode: string, name: string, description: string) => {
  return await postBiz({ s: 'bieexecutive', a: 'snapshot', scc: scenarioCode, nam: name, dsc: description });
};
